import { IOption } from 'app/components/Select';

export const isInsideOptionArray = (reference: IOption[], seaching: IOption[]) => {
	return reference?.reduce(
		(acc, referenceOpt) =>
			seaching?.find(seachingOpt => seachingOpt?.value === referenceOpt?.value) ? (acc = true) : acc,
		false,
	);
};
